import { render, staticRenderFns } from "./TalkView.vue?vue&type=template&id=5b65ebf6&scoped=true"
import script from "./TalkView.vue?vue&type=script&lang=js"
export * from "./TalkView.vue?vue&type=script&lang=js"
import style0 from "./TalkView.vue?vue&type=style&index=0&id=5b65ebf6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b65ebf6",
  null
  
)

export default component.exports